// src/serviceWorkerRegistration.js
//
// Registers public/service-worker.js (this feature's own plan doc, "Real
// Offline Mode for the Cashier/Checkout Screen"). Deliberately minimal —
// no Workbox, no precache manifest injection, no update-prompt UI: the
// service worker itself is network-first for the app shell, so a deployed
// update is picked up the moment connectivity exists with zero extra
// machinery here. CRA 5 copies everything under public/ verbatim to the
// build root, so "/service-worker.js" is always a valid same-origin path
// in production; it only needs to be under HTTPS or localhost, which CRA's
// own dev/build targets already satisfy.
export function register() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js").catch((err) => {
        console.error("Service worker registration failed:", err);
      });
    });
  }
}
